import styled from 'styled-components';
import { H1, SectionParent, BlueButton } from '../../StyledComponents';
import React from 'react';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #fafcff;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  padding-top: 5rem !important;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #4a5376;

  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    color: #ac93ff;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  justify-self: center;
  letter-spacing: normal;
  color: #6a718c;

  max-width: 64rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 48px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

export default () => (
  <div>
    <SectionOne id="section-one-kiosk">
      <HeroTitle>How Can Esper Help Enterprises?</HeroTitle>
      <HeroSubTitle style={{ paddingTop: '1rem' }}>
        With Windows CE and Windows Embedded rolling to the end-of-life by 2020,
        enterprises with large installed bases will face a major decision to go
        with a hardware upgrade, leading to a very high CAPEX or get stuck with
        legacy systems with poor performance.
        <br />
        <br />
        Here’s where we come in. Esper’s full-stack approach gives enterprises
        the ability to run Android on legacy x86 devices without having to
        replace existing hardware. Our cloud-based platform for Android devices
        helps enterprises seamlessly build, deploy, and manage purpose-built
        devices with robust support for diagnosing and debugging devices in the
        field.
      </HeroSubTitle>
      <BlueButtonWrapper>
        <BlueButton
          id="android_x86__request_demo"
          onClick={() => (window.location.href = '/book-demo')}
        >
          Request a demo now
        </BlueButton>
      </BlueButtonWrapper>
    </SectionOne>
  </div>
);
